<bl-modal-content
  #content
  [title]="'編集'"
  [footerButtonType]="modalButtonType.Custom"
>
  <ng-container body>
    <div class="edit-item-label-name">実施予定日</div>
    <div class="contact-settings">
      <div class="radio-bottoms">
        <bl-checkbox
          [(value)]="changeContactScheduleDateDiv"
          [label]="'変更する'"
          (changeEvent)="onChangeProp('changeContactScheduleDateDiv', $event)"
        ></bl-checkbox>
      </div>
      <div class="edit-items">
        <div class="calendar">
          <bl-date
            blCustomFocus
            [(disabled)]="!changeContactScheduleDateDiv"
            [(value)]="contactScheduleDate"
            [defaultEraType]="JapanEraType.Reiwa"
            [viewEraTypeFrom]="JapanEraType.Heisei"
            (changeEvent)="onChangeProp('contactScheduleDate', $event)">
          </bl-date>
        </div>
      </div>
    </div>
    <div class="edit-item-label-name">時間</div>
    <div class="contact-settings">
      <div class="radio-bottoms">
        <bl-checkbox
          [(value)]="changeContactScheduleTimeDiv"
          [label]="'変更する'"
          (changeEvent)="onChangeProp('changeContactScheduleTimeDiv', $event)"
        ></bl-checkbox>
      </div>
      <div class="datetime-width">
        <bl-time
        [(disabled)]="!changeContactScheduleTimeDiv"
          [value]="contactScheduleTime"
          [timeMode]="'minute'"
          (changeEvent)="onChangeProp('contactScheduleTime', $event)"
          [option]="{editable: false, minuteStep: 1}"
        ></bl-time>
      </div>
    </div>
    <div class="edit-item-label-name">担当者</div>
    <div class="contact-settings">
      <div class="radio-bottoms">
        <bl-checkbox
          [(value)]="changeEmployeeCodeDiv"
          [label]="'変更する'"
          (changeEvent)="onChangeProp('changeEmployeeCodeDiv', $event)"
        ></bl-checkbox>
      </div>
      <div class="edit-items">
        <div>
          <div class="input-group edit-item">
            <bl-text-input blCustomFocus
            [(disabled)]="!changeEmployeeCodeDiv"
            [(value)]="employeeName"
            [maxlength]="60"
            [placeholder]="'従業員コード'"
            (changeEvent)="onChangeProp('employeeCode', $event)"
            ></bl-text-input>
            <span class="input-group-btn">
              <button #employeeGuideButton
                class="btn btn-default guide-button" type="button"
                (click)="onClickEmployeeGuide(employeeGuideButton)">
                <span class="icon-icon_guide"></span>
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <div footer>
    <button #cancelButton
      type="button" class="btn btn-default"
      (click)="onCancel()"
    >キャンセル</button>
    <button #okButton
      type="button" class="btn btn-success"
      (click)="onSuccess()"
      [disabled]="!(changeContactScheduleDateDiv || changeContactScheduleTimeDiv || changeEmployeeCodeDiv)"
    >決定</button>
  </div>
</bl-modal-content>



// WEBPACK FOOTER //
// ./src/app/page/contact-list-page/modal/edit-modal.component.html